import { Modal } from "@mui/material";
import { Ptag } from "components/core";
import React, { useState } from "react";
import { BaseButton, ReminderConfirmationModalWrapper } from "./styles";
import Lottie from "react-lottie";
import ReminderAnimation from "assets/lottie/reminder.json";

function ReminderConfirmationModal({ open, handleClose, sendReminder }) {
  const [showAnimation, setShowAnimation] = useState(false);
  const confirmHandler = () => {
    sendReminder();
    setShowAnimation(true);
    setTimeout(() => {
      handleClose();
    }, 3000)
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <ReminderConfirmationModalWrapper>
        {showAnimation ? (
          <section>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: ReminderAnimation,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={60}
              width={60}
              style={{ opacity: "1" }}
              isClickToPauseDisabled
            />
            <Ptag fontSize="20px" fontWeight="600" textAlign="center" marginTop="18px">
              Reminder successfully sent!
            </Ptag>
          </section>
        ) : (
          <section>
            <Ptag
              fontSize="20px"
              fontWeight="600"
              textAlign="center"
              marginBottom="6px"
            >
              Confirm Reminder
            </Ptag>
            <Ptag fontSize="14px" fontWeight="#4a4a4a" textAlign="center">
              Do you want to send a login reminder to the employees now?
            </Ptag>
            <footer>
              <BaseButton variant="outlined" onClick={handleClose}>
                Cancel
              </BaseButton>
              <BaseButton variant="contained" onClick={confirmHandler}>
                Confirm
              </BaseButton>
            </footer>
          </section>
        )}
      </ReminderConfirmationModalWrapper>
    </Modal>
  );
}

export default ReminderConfirmationModal;
